import { IViolationLawsuitType } from 'APIPackage/CatalogsModule/interfaces/IViolationLawsuitType';

import { IViolationLawsuitTypeSelectOption } from '../interfaces/IViolationLawsuitTypeSelectOption';

export const createViolationLawsuitTypeSelectOption = (
  violationLawsuitType: IViolationLawsuitType,
): IViolationLawsuitTypeSelectOption => ({
  ...violationLawsuitType,
  label: `${violationLawsuitType.digitCode} ${violationLawsuitType.name}`,
  value: violationLawsuitType.code,
});
